import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonetadm.widget.memo');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-portal-kreonetadm-widget-memo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonetadm.widget.memo/view.scss */
/* src/app/portal.kreonetadm.widget.memo/view.scss: no such file or directory */`],
})
export class PortalKreonetadmWidgetMemoComponent implements OnInit {
    @Input() title: any;
    @Input() isOpen = true;
    public user = {
        name: '',
        email: '',
        institute: '',
        ins_role: '',
        mobile: '',
        tel: '',
        department: '',
        title: '',

    }

    public async ngOnInit() {
    }

    public async plusUser() {
        const { code, data } = await wiz.call("plus_user", this.user)
        console.log(this.user)
    }


    public async closeModal() {
        this.isOpen = false;
    }

}

export default PortalKreonetadmWidgetMemoComponent;